(() => {
  let t = (l) => {
      if (l && l.classList.contains("shopify-section-header")) {
        var e = document.querySelectorAll(".swiper--mega-menu-desktop"),
          a = document.querySelectorAll(".swiper--mega-menu-mobile"),
          o = document.querySelectorAll(".js-mega-menu-mobile-tabs");
        let t = l.querySelectorAll(".list-menu--megamenu");
        e.forEach((e) => {
          new Swiper(e, {
            speed: 800,
            slidesPerView: 4,
            slidesPerGroup: 4,
            mousewheel: { forceToAxis: !0 },
            spaceBetween: 24,
            pagination: {
              el: e.querySelector(".mega-menu__pagination"),
              clickable: !1,
              type: "custom",
              renderCustom: function (e, t, a) {
                let l = "";
                for (let e = 1; e < a + 1; e++)
                  l =
                    e == t
                      ? `${l}<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`
                      : `${l}<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`;
                return l;
              },
            },
          });
        }),
          a.forEach((e) => {
            new Swiper(e, {
              slidesPerView: 1,
              slidesPerGroup: 1,
              spaceBetween: 8,
              mousewheel: { forceToAxis: !0 },
              speed: 800,
              pagination: {
                el: e.querySelector(".mega-menu__pagination"),
                clickable: !1,
                type: "custom",
                renderCustom: function (e, t, a) {
                  let l = "";
                  for (let e = 1; e < a + 1; e++)
                    l =
                      e == t
                        ? `${l}<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`
                        : `${l}<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`;
                  return l;
                },
              },
              breakpoints: { 750: { slidesPerView: 2, slidesPerGroup: 2 } },
            });
          }),
          o.forEach((e) => {
            let t = e.querySelector(".mega-menu__tabs"),
              a = e.querySelectorAll(".mega-menu__tab"),
              l = e.querySelectorAll(".mega-menu__submenu"),
              o = (e, t) => {
                e.forEach((e) => {
                  e.classList.remove(`mega-menu__${t}--active`);
                });
              },
              n = (e, t, a) => {
                e.forEach((e) => {
                  e.dataset.megaMenuTabId === a &&
                    e.classList.add(`mega-menu__${t}--active`);
                });
              },
              r = (a, e) => {
                e.forEach((e) => {
                  var t;
                  e.classList.contains("mega-menu__tab--active") &&
                    ((t = a.getBoundingClientRect()),
                    (e = e.getBoundingClientRect()).left < t.left
                      ? (a.scrollLeft = e.left + a.scrollLeft - t.left)
                      : e.right > t.right &&
                        (a.scrollLeft = e.right - t.right + a.scrollLeft));
                });
              };
            a.forEach((e) => {
              e.addEventListener("click", () =>
                ((e) => {
                  e = e.dataset.megaMenuTabId;
                  o(a, "tab"),
                    o(l, "submenu"),
                    n(a, "tab", e),
                    n(l, "submenu", e),
                    r(t, a);
                })(e),
              );
            }),
              new ResizeObserver((e) => {
                e.forEach((e) => {
                  t &&
                    (t.style.setProperty("--scroll-width", "0px"),
                    t.style.setProperty(
                      "--scroll-width",
                      t.scrollWidth + "px",
                    ));
                });
              }).observe(e);
          });
        new ResizeObserver((e) => {
          e.forEach((e) => {
            ((e) => {
              let a = l.getBoundingClientRect();
              e.forEach((e) => {
                var t = e.querySelector(".mega-menu");
                t &&
                  ((e = e.getBoundingClientRect()),
                  t.style.removeProperty("top"),
                  a.bottom > e.bottom) &&
                  ((e = a.bottom - e.bottom),
                  (t.style.top = `calc(100% - ${e}px)`));
              });
            })(t);
          });
        }).observe(l);
      }
    },
    e = document.currentScript.parentElement;
  document.addEventListener("DOMContentLoaded", function () {
    t(e);
  }),
    document.addEventListener("shopify:section:load", function (e) {
      t(e.target);
    });
})();
